/**
 * Imposter — player bounds and copy defaults (pass-and-play social deduction).
 */

/** Minimum players for a workable round (everyone gets one clue pass). */
export const IMPOSTER_MIN_PLAYERS = 4;

/** Practical upper bound for one phone passing around the table. */
export const IMPOSTER_MAX_PLAYERS = 10;

/** Label shown to players who are imposters during private reveal. */
export const IMPOSTER_ROLE_CARD_COPY = "You are the imposter";
